export interface ErrorPanelProps {
  readonly title?: string | undefined;
  readonly messages: readonly string[];
  readonly tone?: 'error' | 'warning';
  readonly footnote?: string | undefined;
}

/**
 * Nutzerlesbare Fehler-/Warn-Box — ersetzt die früheren <pre>-Monospace-Blöcke
 * (Cockpit-Validierung, Review-Fehler). Mehrere Meldungen werden als Liste
 * gerendert statt als \n-gejointer String.
 */
const TONES = {
  error: {
    panel: 'border-rose-600 bg-red-50',
    text: 'text-red-800',
  },
  warning: {
    panel: 'border-amber-500 bg-amber-50',
    text: 'text-amber-900',
  },
} as const;

export function ErrorPanel({ title, messages, tone = 'error', footnote }: ErrorPanelProps) {
  const t = TONES[tone];
  return (
    <div role="alert" className={`rounded-sm border-l-4 px-4 py-3 ${t.panel}`}>
      {title && (
        <p className={`font-sans text-xs font-medium uppercase tracking-widest ${t.text}`}>
          {title}
        </p>
      )}
      {messages.length === 1 ? (
        <p className={`${title ? 'mt-2 ' : ''}font-serif text-sm ${t.text}`}>{messages[0]}</p>
      ) : (
        <ul
          className={`${title ? 'mt-2 ' : ''}list-disc space-y-1 pl-5 font-serif text-sm ${t.text}`}
        >
          {messages.map((m) => (
            <li key={m}>{m}</li>
          ))}
        </ul>
      )}
      {footnote && <p className={`mt-3 font-serif text-xs italic ${t.text}`}>{footnote}</p>}
    </div>
  );
}
